// extracted by mini-css-extract-plugin
export var searchHeader = "_8v-0";
export var searchHeaderDark = "_8v-1";